<div class="pageTitle">
  Admin: PAYG
</div>

<div class="titleSpacerBelow">&nbsp;</div>

<div class="sectionContainer">

  <div class="sectionHeader">

    <mat-tab-group [(selectedIndex)]="selectedTabIndex"
                   (selectedIndexChange)="tabChanged($event)">

      <!-- =====================================================
           CANDIDATES
           ===================================================== -->
      <mat-tab label="Candidates">

        <!-- FILTERS -->
        <div class="toolbar-row">

          <div class="toolbar-left">

            <!-- Search -->
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Search</mat-label>

              <input matInput
                     [(ngModel)]="searchTerm"
                     (keyup)="applyFilter()"
                     placeholder="Probate, Beneficiary, URN or Email">
            </mat-form-field>


            <!-- Bequest Type -->
            <mat-form-field appearance="outline" class="bequest-field">

              <mat-label>Bequest Type</mat-label>

              <mat-select multiple
                          [(ngModel)]="selectedBequestTypes"
                          (selectionChange)="applyFilter()">

                <mat-option *ngFor="let type of bequestTypes"
                            [value]="type">

                  {{ type }}

                </mat-option>

              </mat-select>

            </mat-form-field>


            <!-- Estate Min -->
            <mat-form-field appearance="outline" class="money-field">

              <mat-label>Min Estate (£)</mat-label>

              <input matInput
                     type="number"
                     step="100"
                     [(ngModel)]="minEstateValue"
                     (input)="applyFilter()">

            </mat-form-field>


            <!-- Estate Max -->
            <mat-form-field appearance="outline" class="money-field">

              <mat-label>Max Estate (£)</mat-label>

              <input matInput
                     type="number"
                     step="100"
                     [(ngModel)]="maxEstateValue"
                     (input)="applyFilter()">

            </mat-form-field>


            <!-- Issue Date From -->
            <mat-form-field appearance="outline" class="date-field">

              <mat-label>Issue Date From</mat-label>

              <input matInput
                     [matDatepicker]="issueFromPicker"
                     [(ngModel)]="issueDateFrom"
                     (dateChange)="applyFilter()">

              <mat-datepicker-toggle matSuffix
                                     [for]="issueFromPicker">
              </mat-datepicker-toggle>

              <mat-datepicker #issueFromPicker></mat-datepicker>

            </mat-form-field>


            <!-- Issue Date To -->
            <mat-form-field appearance="outline" class="date-field">

              <mat-label>Issue Date To</mat-label>

              <input matInput
                     [matDatepicker]="issueToPicker"
                     [(ngModel)]="issueDateTo"
                     (dateChange)="applyFilter()">

              <mat-datepicker-toggle matSuffix
                                     [for]="issueToPicker">
              </mat-datepicker-toggle>

              <mat-datepicker #issueToPicker></mat-datepicker>

            </mat-form-field>

          </div>

        </div>
        <br /> 

        <!-- EMAIL FILTERS - SECOND LINE -->
        <div class="email-filter-row">

          <div class="email-filter">

            <mat-checkbox [(ngModel)]="showWithEmail"
                          (change)="applyFilter()">

              With Email ({{ withEmailCount }})

            </mat-checkbox>


            <mat-checkbox [(ngModel)]="showWithoutEmail"
                          (change)="applyFilter()">

              Without Email ({{ withoutEmailCount }})

            </mat-checkbox>


            <mat-checkbox [(ngModel)]="showWithAIEmail"
                          (change)="applyFilter()">

              With AI Email ({{ withAIEmailCount }})

            </mat-checkbox>


            <mat-checkbox [(ngModel)]="showWithoutAIEmail"
                          (change)="applyFilter()">

              Without AI Email ({{ withoutAIEmailCount }})

            </mat-checkbox>


            <mat-checkbox [(ngModel)]="showFoundAIEmail"
                          (change)="applyFilter()">

              Found AI Email ({{ foundAIEmailCount }})

            </mat-checkbox>

          </div>

        </div>
        <br />

        <!-- ACTIONS -->
        <div class="toolbar-actions">

          <div class="left-actions">

            <button mat-raised-button
                    color="primary"
                    class="compose-button"
                    (click)="openEmailDialog()">

              <mat-icon>mail</mat-icon>

              Compose Email ({{ selectedCount }})

            </button>


            <div class="selection-actions">

              <mat-checkbox [checked]="allSelected"
                            (change)="selectAll()">

                Select All

              </mat-checkbox>


              <mat-checkbox [checked]="false"
                            (change)="deselectAll()">

                Deselect All

              </mat-checkbox>

            </div>

          </div>


          <!-- RIGHT SIDE -->
          <div class="right-actions">

            <button mat-stroked-button
                    type="button"
                    (click)="refresh()">

              <mat-icon>refresh</mat-icon>

              Refresh

            </button>

          </div>

        </div>


        <!-- PAGINATOR -->
        <div class="paginator-row">

          <mat-paginator #paginator
                         [length]="filteredPaygCases.length"
                         [pageSize]="pageSize"
                         [pageSizeOptions]="[25, 50, 100, 200]"
                         (page)="pageChanged($event)"
                         showFirstLastButtons>

          </mat-paginator>

        </div>


        <!-- NO RESULTS -->
        <div *ngIf="pagedPaygCases.length === 0"
             class="no-results">

          No PAYG candidates found.

        </div>


        <!-- PAYG TABLE -->
        <div class="payg-list"
             *ngIf="pagedPaygCases.length > 0">

          <!-- HEADER -->
          <div class="payg-row header">

            <div class="col select">
              Send
            </div>

            <div class="col probate">
              Probate ID
            </div>

            <div class="col imported">
              Issue Date
            </div>

            <div class="col beneficiary">
              Beneficiary
            </div>

            <div class="col urn">
              URN
            </div>

            <div class="col email">
              Email
            </div>

            <div class="col aiEmail">
              AI Email
            </div>

            <div class="col aiStatus">
              AI Status
            </div>

            <div class="col type">
              Bequest Type
            </div>

            <div class="col estate">
              Estate Value
            </div>

            <div class="col bequest">
              Bequest Value
            </div>

            <div class="col verified">
              Verification
            </div>

            <div class="col status">
              Subscribed
            </div>

          </div>


          <!-- ROWS -->
          <div class="payg-row"
               *ngFor="let item of pagedPaygCases">

            <div class="col select">

              <mat-checkbox [(ngModel)]="item.sendEmail">
              </mat-checkbox>

            </div>


            <div class="col probate">
              {{ item.probateId }}
            </div>


            <div class="col imported">
              {{ item.issueDate | date:'dd/MM/yyyy' }}
            </div>


            <div class="col beneficiary"
                 [title]="item.beneficiaryName">

              {{ item.beneficiaryName }}

            </div>


            <div class="col urn"
                 [title]="item.beneficiaryURN">

              {{ item.beneficiaryURN }}

            </div>


            <div class="col email"
                 [title]="item.email">

              {{ item.email || 'Not available' }}

            </div>


            <div class="col aiEmail"
                 [title]="item.aiEmail">

              {{ item.aiEmail || 'Not available' }}

            </div>


            <div class="col aiStatus"
                 [title]="item.aiStatus">

              {{ item.aiStatus || '-' }}

            </div>


            <div class="col type"
                 [title]="item.bequestType">

              {{ item.bequestType || '-' }}

            </div>


            <div class="col estate">

              {{ item.estateValue | currency:'GBP':'symbol':'1.0-0' }}

            </div>


            <div class="col bequest">

              <ng-container *ngIf="item.bequestType === 'Absolute Residual'; else currencyBequest">

                {{ item.bequestValue }}%

              </ng-container>

              <ng-template #currencyBequest>

                {{ item.bequestValue | currency:'GBP':'symbol':'1.0-0' }}

              </ng-template>

            </div>


            <div class="col verified">

              {{ item.verificationDate || '-' }}

            </div>


            <div class="col status">

              <span class="status-pill"
                    [ngClass]="item.subscribed ? 'active' : 'inactive'">

                {{ item.subscribed ? 'Yes' : 'No' }}

              </span>

            </div>

          </div>

        </div>

      </mat-tab>


      <!-- =====================================================
           EMAILS SENT
           ===================================================== -->
      <mat-tab label="Emails Sent">

        <div class="history-container">

          <div *ngIf="paygEmails.length === 0"
               class="no-results">

            No PAYG emails found.

          </div>


          <div class="history-list"
               *ngIf="paygEmails.length > 0">

            <div class="history-row history-header">

              <div class="history-col date">
                Date
              </div>

              <div class="history-col probate">
                Bequest ID
              </div>

              <div class="history-col beneficiary">
                Beneficiary ID
              </div>

              <div class="history-col email">
                Email
              </div>

              <div class="history-col subject">
                Subject
              </div>

              <div class="history-col status">
                Status
              </div>

              <div class="history-col sentBy">
                Sent By
              </div>

            </div>


            <div class="history-row"
                 *ngFor="let item of paygEmails">

              <div class="history-col date">
                {{ item.sentDate | date:'dd/MM/yyyy HH:mm' }}
              </div>

              <div class="history-col probate">
                {{ item.bequestId }}
              </div>

              <div class="history-col beneficiary">
                {{ item.beneficiaryId }}
              </div>

              <div class="history-col email"
                   [title]="item.email">

                {{ item.email }}

              </div>

              <div class="history-col subject"
                   [title]="item.subjectRendered">

                {{ item.subjectRendered }}

              </div>

              <div class="history-col status">
                <span class="history-status">
                  {{ item.status || '-' }}
                </span>
              </div>

              <div class="history-col sentBy">
                {{ item.sentBy || '-' }}
              </div>

            </div>

          </div>

        </div>

      </mat-tab>


      <!-- =====================================================
           PAID
           ===================================================== -->
      <mat-tab label="Paid">

        <div class="history-container">

          <div *ngIf="paygPaid.length === 0"
               class="no-results">

            No PAYG payments found.

          </div>


          <div class="history-list"
               *ngIf="paygPaid.length > 0">

            <div class="history-row history-header">

              <div class="history-col date">
                Paid Date
              </div>

              <div class="history-col probate">
                Probate ID
              </div>

              <div class="history-col beneficiary">
                Beneficiary
              </div>

              <div class="history-col email">
                Email
              </div>

              <div class="history-col amount">
                Amount
              </div>

              <div class="history-col status">
                Status
              </div>

              <div class="history-col stripe">
                Stripe Session
              </div>

            </div>


            <div class="history-row"
                 *ngFor="let item of paygPaid">

              <div class="history-col date">
                {{ item.paidDate | date:'dd/MM/yyyy HH:mm' }}
              </div>

              <div class="history-col probate">
                {{ item.probateId || '-' }}
              </div>

              <div class="history-col beneficiary"
                   [title]="item.beneficiaryName">

                {{ item.beneficiaryName || '-' }}

              </div>

              <div class="history-col email"
                   [title]="item.email">

                {{ item.email || '-' }}

              </div>

              <div class="history-col amount">

                {{ item.amount | currency:'GBP':'symbol':'1.2-2' }}

              </div>

              <div class="history-col status">

                <span class="paid-status">
                  {{ item.status || '-' }}
                </span>

              </div>

              <div class="history-col stripe"
                   [title]="item.stripeCheckoutSessionId">

                {{ item.stripeCheckoutSessionId || '-' }}

              </div>

            </div>

          </div>

        </div>

      </mat-tab>

    </mat-tab-group>

  </div>

</div>
